<template>
  <DialogEx :options="dialogOptions" :title="fileName">
    <div class="img-preview-body" style="background:#fff;height:70vh;display:flex;flex-direction:column;">
      <!-- 工具栏：放大 / 缩小 / 旋转 / 复位 -->
      <div class="img-preview-toolbar" style="padding:8px;text-align:center;border-bottom:1px solid #ebeef5;">
        <el-button-group>
          <el-button size="mini" icon="el-icon-zoom-out" @click="zoomOut">缩小</el-button>
          <el-button size="mini" @click="reset">{{ Math.round(scale * 100) }}%</el-button>
          <el-button size="mini" icon="el-icon-zoom-in" @click="zoomIn">放大</el-button>
        </el-button-group>
        <el-button-group style="margin-left:12px;">
          <el-button size="mini" icon="el-icon-refresh-left" @click="rotateLeft">向左旋转</el-button>
          <el-button size="mini" icon="el-icon-refresh-right" @click="rotateRight">向右旋转</el-button>
        </el-button-group>
      </div>
      <!-- 图片区：可滚动查看放大/旋转后的内容 -->
      <div style="flex:1;overflow:auto;text-align:center;padding:10px;">
        <img
          v-if="previewUrl"
          :src="previewUrl"
          :style="imgStyle"
        />
      </div>
    </div>
  </DialogEx>
</template>

<script>
import sha from '../../scripts/sha.js'
import Cookie from '../../scripts/cookie.js'
export default {
  name: 'ImagePreviewDialog',
  props: {
    // 可覆盖下载接口基础地址；不传则按 domain cookie 在 apiCustomerUrl / apiBaseUrl 之间选择
    baseUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogOptions: { visible: false, size: 'large', showFooter: false },
      fileName: '',
      previewUrl: '',
      scale: 1,
      rotate: 0,
    }
  },
  computed: {
    imgStyle() {
      return {
        transform: 'scale(' + this.scale + ') rotate(' + this.rotate + 'deg)',
        transformOrigin: 'center center',
        transition: 'transform .2s',
        maxWidth: '100%',
        maxHeight: '100%',
      }
    },
  },
  methods: {
    // fileName: 文件名称（含扩展名）；fileUrl: 后端存储地址（AttachmentUrl / CertFileUrl 等）
    // 与 FilePreviewDialog 同款入参，但图片用 <img> 直接显示（不进 iframe 组件）
    open(fileName, fileUrl) {
      if (!fileUrl) {
        this.$message.warning('该记录未上传附件')
        return
      }
      // 每次打开重置缩放/旋转状态
      this.scale = 1
      this.rotate = 0
      this.fileName = fileName || fileUrl || ''
      var domain = Cookie.get(Cookie.domain)
      var base = this.baseUrl || (domain ? window.AppConfig.apiCustomerUrl : window.AppConfig.apiBaseUrl)
      this.previewUrl =
        base +
        'omsapi/files/download?file=' +
        encodeURIComponent(fileName || '') +
        '&url=' +
        encodeURIComponent(fileUrl) +
        '&token=' +
        sha.getToken() +
        '&inline=1'
      this.dialogOptions.visible = true
    },
    zoomIn() {
      this.scale = Math.min(this.scale * 1.2, 5)
    },
    zoomOut() {
      this.scale = Math.max(this.scale / 1.2, 0.2)
    },
    rotateLeft() {
      this.rotate -= 90
    },
    rotateRight() {
      this.rotate += 90
    },
    reset() {
      this.scale = 1
      this.rotate = 0
    },
    close() {
      this.previewUrl = ''
      this.dialogOptions.visible = false
    },
  },
}
</script>

<style></style>
